import classNames from "classnames";
import type { ComponentPropsWithoutRef, ForwardedRef, MouseEvent } from "react";
import { forwardRef } from "react";
import type { FlexTableColumnPropsBase } from "../types";

type ExposedHtmlElementProps = Pick<ComponentPropsWithoutRef<"div">, "onAnimationEnd">;

type Props = FlexTableColumnPropsBase & ExposedHtmlElementProps;

const FlexTableColumn = (
    { className, style, columnConfig, columnCells, isLast, colMinWidth, onDragStart, ...htmlElementProps }: Props,
    ref: ForwardedRef<HTMLDivElement>,
) => {
    const checkIsResizable = (): boolean => {
        if (typeof columnConfig.isResizable === "undefined") {
            const width = columnConfig.width || columnConfig.minWidth;

            return !isLast && width != null && width > colMinWidth;
        }

        return columnConfig.isResizable;
    };

    const handleOnMouseDown = (event: MouseEvent): void => {
        onDragStart(columnConfig, event);
    };

    return (
        <div
            ref={ref}
            className={classNames("u-relative", className, columnConfig.columnClass, columnConfig.isSortedClass)}
            style={style}
            {...htmlElementProps}
        >
            {columnCells}

            {checkIsResizable() ? (
                <div
                    className="resizeable-border"
                    onMouseDown={handleOnMouseDown}
                />
            ) : null}
        </div>
    );
};

export default forwardRef(FlexTableColumn);
